// extracted by mini-css-extract-plugin
export var attribution = "_9p-4";
export var authorName = "_9p-5";
export var quote = "_9p-3";
export var testimonial = "_9p-2";
export var trustedBy = "_9p-0";
export var trustedByLabel = "_9p-1";